import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24')
];

export const server_loads = [];

export const dictionary = {
		"/": [3],
		"/address": [4],
		"/address/list": [5],
		"/address/manage": [6],
		"/healthcheck": [7],
		"/heartbeat": [8],
		"/ingest": [9],
		"/login": [10],
		"/order": [11],
		"/order/native": [12],
		"/payments": [13,[2]],
		"/payments/CARD": [14,[2]],
		"/payments/CASH": [15,[2]],
		"/payments/CUSTOM": [16,[2]],
		"/payments/EMI": [17,[2]],
		"/payments/EMI/pay": [18,[2]],
		"/payments/EMI/plans": [19,[2]],
		"/payments/NB": [20,[2]],
		"/payments/UPI": [21,[2]],
		"/payments/WALLET": [22,[2]],
		"/user": [23],
		"/user/profile": [24]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),

	reroute: (() => {})
};

export { default as root } from '../root.svelte';